module.exports = __webpack_public_path__ + "img/SSS-M-6.26f95dc9.svg";